<div class="permission-section" [formGroup]="permissionsForm">
      <div class="toggle-container">
        <span class="toggle-label">{{ label }}</span>
        <div class="toggle-switch" 
             [class.active]="value" 
             (click)="toggle()"
             [attr.aria-checked]="value"
             role="switch"
             tabindex="0"
             (keydown.space)="toggle()"
             (keydown.enter)="toggle()">
          <div class="toggle-slider">
            <div class="toggle-handle"></div>
          </div>
        </div>
      </div>
      
      <!-- Expanded permissions when toggle is ON -->
      <div class="permissions-expanded" *ngIf="value && isReady" >
        <div class="permission-row">
          <div class="checkbox-container">
            <input type="checkbox" 
                   id="canRead"
                   formControlName="read"
                   (change)="onPermissionChange()">
            <label for="canRead" class="checkbox-label">Can Read</label>
          </div>
          <div class="full-access-toggle">
            <div class="toggle-switch"
                 [class.active]="full" 
                 (click)="toggleFullAccess()">
              <div class="toggle-slider">
                <div class="toggle-handle"></div>
              </div>
            </div>
            <span class="full-access-label">Full access</span>
          </div>
        </div>
        
        <div class="permission-row">
          <div class="checkbox-container">
            <input type="checkbox" 
                   id="canEdit"
                   formControlName="edit"
                   (change)="onPermissionChange()">
            <label for="canEdit" class="checkbox-label">Can Edit</label>
          </div>
        </div>
        
        <div class="permission-row">
          <div class="checkbox-container">
            <input type="checkbox" 
                   id="canDelete"
                   formControlName="delete" 
                   (change)="onPermissionChange()">
            <label for="canDelete" class="checkbox-label">Can Delete</label>
          </div>
        </div>
      </div>
    </div>